import axios from 'axios';

import { RESEARCH_URL, TECHNIQUE_URL, WAVELIGHT_URL, WAVE_URL } from './url';

import {
  WavelightMeasurements,
  WavelightPerson,
  WavelightStudy,
} from './types';
import { Pagination, WavelightAlgorithms, WaveTechniques } from '../../types';

import { getAuthToken } from '../../utils';

export const getAllWavelightItemsRequest = async ({
  limit,
  page,
}: Pagination) => {
  const token = getAuthToken();
  const response = await axios.get(
    `${WAVELIGHT_URL}?page=${page}&limit=${limit}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getWavelightItemRequest = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.get(`${WAVELIGHT_URL}/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const downloadVideoRequest = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.get(`${WAVELIGHT_URL}/download/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const disableItemRequest = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/disable/${id}/`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const savePersonRequest = async (
  id: string,
  person: WavelightPerson,
) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/update-person/${id}/`,
    person,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const saveStudyRequest = async (id: string, study: WavelightStudy) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/update-study/${id}/`,
    study,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const saveMeasurementsRequest = async (
  id: string,
  measurements: WavelightMeasurements,
) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/update-measurements/${id}/`,
    measurements,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getAllResearchForItem = async ({
  id,
  limit,
  page,
}: { id: string } & Pagination) => {
  const token = getAuthToken();
  const response = await axios.get(
    `${RESEARCH_URL}/wavelight/${id}?page=${page}&limit=${limit}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getAllWavesForItem = async ({
  id,
  limit,
  page,
}: { id: string } & Pagination) => {
  const token = getAuthToken();
  const response = await axios.get(
    `${WAVELIGHT_URL}/${id}/waves?page=${page}&limit=${limit}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const startAlgorithmCalculationRequest = async (
  id: string,
  algorithm: WavelightAlgorithms,
) => {
  const token = getAuthToken();
  const response = await axios.post(
    `${WAVELIGHT_URL}/start-calculation/${id}/`,
    {
      algorithm,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getWavelightWaveRequest = async (id: string, wid: string) => {
  const token = getAuthToken();
  const response = await axios.get(`${WAVELIGHT_URL}/${id}/waves/${wid}/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const startTechniqueCalculationRequest = async (
  id: string,
  technique: WaveTechniques,
) => {
  const token = getAuthToken();
  const response = await axios.post(
    `${WAVE_URL}/start-calculation/${id}/`,
    {
      technique,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getAllTechniquesForItem = async ({
  id,
  limit,
  page,
}: { id: string } & Pagination) => {
  const token = getAuthToken();
  const response = await axios.get(
    `${WAVE_URL}/${id}/techniques?page=${page}&limit=${limit}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getTechniqueRequest = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.get(`${TECHNIQUE_URL}/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
